<app-action-icon size="sm" (click)="activateScanner()" class="ml-2" icon="barcode-read"></app-action-icon>
<app-scanner #scanner (change)="scannerValueChanged($event)"></app-scanner>
